import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TreeChoiceService {

    // Place
    private readonly place = new Map<string, string[]>();


    setPlace(key: string, value: string[]): Map<string, string[]> {
        return this.place.set(key, value);
    }

    getPlace(key: string): string[] {
        return this.place.get(key);
    }

    hasPlace(key: string): boolean {
        return this.place.has(key);
    }

    deletePlace(key: string): boolean {
        return this.place.delete(key);
    }

    reset() {
        this.place.clear();
    }
}
